import { Button, Callout } from "@blueprintjs/core"
import { Fragment, useEffect, useState } from "react"
import { IPost } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { IPETest, PE_TEST_QUESTION_TYPE } from "src/modules/pe-tests-module/data/interfaces"
import { ITestsStore, useTestsStore } from "src/modules/pe-tests-module/data/store"
import useTestCategories from "src/modules/pe-tests-module/hooks/useTestCategories"

/* Protopia Ecosystem component */
export interface IDiagramProps {
   results?: any[]
   test?: IPETest
   width?: number
}
const Diagram = ( props: IDiagramProps ): JSX.Element => {    
    //console.log( props.test, )
    const PETestCategory: IPost     = useTestCategories()
    const currentTest : IPETest     = useTestsStore((state:ITestsStore) => state.currentTest) 
    const currentResults: any[]     = useTestsStore((state:ITestsStore) => state.results) 
     
    const results: any[]    = props.results?.length ? props.results : currentResults
    const test: IPETest     = props.test            ? props.test    : currentTest

    const [isError, setIsError]     = useState<boolean>(false)
    const points                    = useSyncState<number[]>([])
    
    const getPoints = () : number[] => {
        
        if( !results || !Array.isArray(test.questions) ) {
            
            setIsError(true)
        }
        //console.log( test, props.results, results )
        let points: number[] = []
        results
            .filter(r => !!r)
            .forEach(r => { 
                test.questions.forEach(q => {
                    if(q.type !== PE_TEST_QUESTION_TYPE.RANGE) return 
                    const answer = q.answers.find(a => a.id === r.answer_id)
                    if(!!answer && !!answer.pe_test_category?.length) {
                        if( !points[ answer.pe_test_category[0].id ]) {
                            points[ answer.pe_test_category[0].id ] = 0
                        }
                        points[ answer.pe_test_category[0].id ] += r.value/100 * (q.range || 1 )
                    }
                })
            })
        points = points.filter( p => typeof p !== "undefined")
        // console.log(points)
        return points
    }
    useEffect(() => {
        points.set( getPoints() )
    }, [])

    if( !results || !Array.isArray(test.questions) ) {
        setIsError(true)
    }

    // console.log( !points.get().length )

    if( !points.get().length  ) return <div></div>

    const max = Math.ceil(Math.max.apply( null, points.get()))
    const width = PETestCategory.length
    const CELL_WIDTH = !!props.width ? ( props.width / width ) : 100
    const STEP_HEIGHT = max < 50 ? 5 : 10
    const CELL_HEIGHT = 130 / max * STEP_HEIGHT 
    const SWITCH_X = 105
    const SWITCH_Y = 300
    const height = Math.ceil( max / STEP_HEIGHT ) + 1  
    const w = (width - 1) * CELL_WIDTH
    const h = height * CELL_HEIGHT 

    const pnts = points.get().map( (point , n)=> {
        const y = ( Number(point / STEP_HEIGHT || 0) )
        // console.log( y *  STEP_HEIGHT, PETestCategory[n]?.title, n )
        return `${CELL_WIDTH * n + SWITCH_X},${ h - CELL_HEIGHT * y }`
    })

    // console.log( max, STEP_HEIGHT, CELL_HEIGHT )
    
    return isError
        ?
        <Callout className="p-5">
            <div className="lead">
                {__("There is no right result data")}
            </div>
            <Button variant="minimal" onClick={() => setIsError(false)}>
                Ok
            </Button>
        </Callout>
        :
        <svg 
            className="diagram-results"
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0" 
            y="0"
            width={w + SWITCH_X + 10}
            height={h + SWITCH_Y}
            viewBox={`0 0 ${w + SWITCH_X + 10} ${h}`} 
            xmlSpace="preserve"
        >
            <rect x={SWITCH_X + 2} y="2" fill="transparent" strokeWidth="1" strokeMiterlimit="10" width={w - 0} height={h - 2} /> 
            {
                Array( height - 1 ).fill("").map( (_ , i)=> {
                    const y = ( height - (i  + 1) ) * CELL_HEIGHT
                    return <Fragment key={i}>
                        <line x1={SWITCH_X + 2} y1={y} x2={w + SWITCH_X - 2} y2={y} strokeWidth="0.5" strokeMiterlimit="10" strokeDasharray="2,4"/> 
                        <text x={SWITCH_X - 20} y={y} fontSize={10} width={SWITCH_X - 20} dominantBaseline="middle" textAnchor="end" fontWeight={100} fontFamily="Open Sans" letterSpacing={2} >
                            {(i + 1) * STEP_HEIGHT}
                        </text>
                        <line x1={SWITCH_X - 7} y1={y} x2={SWITCH_X + 2 } y2={y} strokeWidth="1" strokeMiterlimit="10" /> 
                    </Fragment>
                })
            }
            {
                Array( width ).fill("").map( (_ , i)=> {
                    const x = ( i ) * CELL_WIDTH + SWITCH_X
                    return <Fragment key={i}>
                        <line x1={x + 2} y1="2" x2={x + 2} y2={h - 2} strokeWidth="0.5" strokeMiterlimit="10" strokeDasharray="2,4" />
                        <line x1={x + 2} y1={h - 2} x2={ x + 2} y2={ h + 10 } strokeWidth="1" strokeMiterlimit="10" />
                        <g transform={`translate(${x},${h + 15})`}>
                            <text
                                fontSize={ 8 } 
                                width={ SWITCH_Y } 
                                dominantBaseline="middle" 
                                textAnchor="end" 
                                fontWeight={ 100 } 
                                fontFamily="Open Sans" 
                                letterSpacing={ 2 }
                                transform=" rotate(-45)" 
                            >
                                {PETestCategory[i].title.substring(0, 30)}
                            </text>
                        </g>
                    </Fragment>
                })
            }
            <polyline 
                fill="transparent" 
                stroke="#C91717" 
                strokeWidth="4" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeMiterlimit="10" 
                points={pnts.join(" ")}
            />
            {
                points.get().map((point, n) => {
                    const y = ( Number(point / STEP_HEIGHT || 0) )
                    const xx = CELL_WIDTH * n + SWITCH_X
                    const yy = h - CELL_HEIGHT * y
                    return <g transform={`translate(${xx},${yy})`} x={ xx } y={ yy } className="point" key={n} >
                        <circle r={5} cx={ 0 } cy={ 0 } data-point={point} fill="#FFFFFF" stroke="#C91717" strokeWidth={1} /> 
                        <g transform={`translate(${ points.get().length - 1 === n ? -33 : n === 0 ? 5 : -10 },${-30})`} className="tooltip-">
                            <rect fill="#111111" x={ 0 } y={ 0 } width={30} height={18} stroke="transparent"  rx="2" ry="2" className="tooltip"/>
                            <text fontSize={ 9 } letterSpacing={ 2 } x={ 5 } y={ 12 } width={30} height={16} className="tooltip">{Math.floor(point)}</text>
                        </g>
                    </g>
                })
            }
        </svg>
}
export default Diagram